module.exports = __webpack_public_path__ + "img/9788949120645.74fc538c.jpg";